import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type InitialAuthState = {
    contactId: string | null,
    memberToken: string | null,
    isAuthenticated: boolean,
    isLoading: boolean,
    error: string | null,
}

const initialAuthState: InitialAuthState = {
    contactId: null,
    memberToken: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
};

const reducers = {
    setUser: (state, action: PayloadAction<{memberToken: string; contactId:string}>) => {
        const { memberToken, contactId } = action.payload;

        return {
            ...state,
            isAuthenticated: true,
            contactId,
            memberToken,
        };
    },
    setError: (state, action: PayloadAction<string>) => {
        state.error = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
        state.isLoading = action.payload;
    },
    resetUser: (state) => ({
        ...state,
        contactId: null,
        memberToken: null,
        accessToken: null,
        isAuthenticated: false,
    }),
};

const authSlice = createSlice({
    name: 'authSlice',
    initialState: initialAuthState,
    reducers,
});

export default authSlice;
